export var Ident;
(function (Ident) {
    let counter = 4096;
    function nextCounter() {
        return (++counter % Number.MAX_SAFE_INTEGER).toString(16);
    }
    function next(prefix = 'i', suffix = '') {
        return prefix + nextCounter() + suffix;
    }
    Ident.next = next;
})(Ident || (Ident = {}));
